import { FileText } from 'lucide-react'

function getFileExtension(name) {
  if (!name) return ''
  const ext = name.split('.').pop()?.toLowerCase()
  return ext || ''
}

function getDocumentName(citation) {
  if (citation.documentName) return citation.documentName
  if (citation.documentS3Key) return citation.documentS3Key.split('/').pop() || 'Unknown document'
  return 'Unknown document'
}

export default function SourceCard({ citation, onClick }) {
  const name = getDocumentName(citation)
  const ext = getFileExtension(name)
  const isPdf = ext === 'pdf'
  const badgeLabel = isPdf ? 'PDF' : ext.toUpperCase() || 'DOC'

  return (
    <button
      onClick={() => onClick(citation)}
      className="w-full text-left flex items-start gap-2.5 p-2.5 rounded-lg border border-slate-200 bg-white hover:bg-slate-50 hover:border-slate-300 transition-colors group"
    >
      <div className="flex-shrink-0 w-8 h-8 rounded-md bg-primary-50 text-primary-600 flex items-center justify-center">
        <FileText size={16} />
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-1.5 mb-0.5">
          <span className="text-xs font-medium text-slate-800 truncate">{name}</span>
          <span className={`flex-shrink-0 text-[10px] font-semibold px-1.5 py-0.5 rounded ${isPdf ? 'bg-red-100 text-red-700' : 'bg-slate-100 text-slate-600'}`}>
            {badgeLabel}
          </span>
          {citation.pageNumber && (
            <span className="flex-shrink-0 text-[10px] text-slate-400">p.{citation.pageNumber}</span>
          )}
        </div>
        {citation.snippet && (
          <p className="text-[11px] text-slate-500 leading-snug line-clamp-2">
            {citation.snippet}
          </p>
        )}
      </div>
    </button>
  )
}
